import React, { useEffect, useState } from 'react';
import NavigationExact from '../components/NavigationExact';
import FooterExact from '../components/FooterExact';

const UploadsPage = () => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Backend disabled — show informational message instead of fetching uploads
    setFiles([]);
    setLoading(false);
  }, []);

  return (
    <>
      <NavigationExact />
      <main className="pt-20 min-h-[60vh] bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-2xl font-bold mb-6">Uploaded Applications</h1>

          {loading ? (
            <p>Loading...</p>
          ) : (
            <div className="text-gray-600">
              Backend uploads are disabled in this build. Uploaded files are not available.
            </div>
          )}
        </div>
      </main>
      <FooterExact />
    </>
  );
};

export default UploadsPage;
